// extracted by mini-css-extract-plugin
export default {"flexcontrol":"articles_flexcontrol__egP3L","title":"articles_title__KLOdd","buttoncontroller":"articles_buttoncontroller__bUnJr","buttonmove":"articles_buttonmove__0ITMl"};